import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        textAlign: 'center' as const,
        display: 'inline-flex' as const,
        alignItems: 'center' as const,
        justifyContent: 'center' as const,
        textTransform: 'uppercase' as const,
        cursor: 'pointer' as const
    },
    mainButtonStyle: {
        height: '55px',
        width: '200px',
        borderRadius: '3px',
        backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLighter || '#0096ff'
    },
    mainButtonSmallStyle: {
        height: '38px',
        width: '100px',
        margin: '0.3rem',
        borderRadius: '3px',
        backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLighter || '#0096ff'
    },
    mainButtonSlimStyle: {
        height: '50px',
        width: '400px',
        borderRadius: '3px',
        backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLighter || '#0096ff',
        '&:disabled': { backgroundColor: theme?.app?.applicationColors.enumColors.greyLight || '#333333' }
    },
    whiteSlimStyle: {
        height: '50px',
        width: '400px',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.white || '#fff'}`,
        borderRadius: '2px',
        backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLight || 'rgba(126, 155, 218, 0.9)'
    },
    blueSlimStyle: {
        height: '35px',
        width: '300px',
        borderRadius: '2px',
        border: `1px solid ${theme?.app?.clientTheme.colors.buttons.primaryColorLighter || '#0096ff'}`,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#ffffff'
    },
    noBgBlue: {
        height: '50px',
        padding: '0 2rem',
        fontSize: '.9rem',
        background: 'none' as const,
        border: `1px solid ${theme?.app?.clientTheme.colors.primaryColor || '#375073'}`,
        borderRadius: '26px',
        '&:hover:enabled': {
            backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#f3f3f3',
            border: `1px solid ${theme?.app?.clientTheme.colors.primaryColorLight || '#375073'}`
        }
    },
    greenSubmit: {
        minWidth: '125px',
        padding: '0.94rem 0.75rem',
        height: '25px',
        marginRight: '1rem !important',
        backgroundColor: '#5AAC01',
        '&:hover': { backgroundColor: '#A5D673' },
        borderRadius: '26px',
        border: 'none' as const,
        '&:disabled': {
            backgroundColor: '#C8C8C8',
            cursor: 'default' as const
        }
    },
    greenSubmitTextStyle: {
        color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF',
        fontSize: '13px !important'
    },
    redSubmit: {
        width: '125px',
        padding: '0.94rem 0.75rem',
        fontSize: '13px',
        height: '25px',
        marginRight: '1rem !important',
        backgroundColor: '#EA3323',
        '&:hover': { backgroundColor: '#E75F59' },
        borderRadius: '26px',
        border: 'none' as const,
        '&:disabled': {
            backgroundColor: '#C8C8C8',
            cursor: 'default' as const
        }
    },
    redSubmitTextStyle: {
        color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF',
        fontSize: '13px !important'
    },
    cancelButtonStyle: {
        height: '50px',
        width: '300px',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.grey || '#9b9b9b'}`,
        borderRadius: '3px',
        backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLight || 'rgba(126, 155, 218, 0.9)'
    },
    cancelButtonSmallStyle: {
        height: '38px',
        width: '100px',
        margin: '0.3rem',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.grey || '#9b9b9b'}`,
        borderRadius: '3px'
    },
    cancelButtonWhite: {
        border: 'none',
        fontSize: '22px',
        color: theme?.app?.applicationColors.enumColors.white || '#fff',
        backgroundColor: 'unset' as const
    },
    submitButtonStyle: {
        height: '50px',
        width: '300px',
        borderRadius: '26px',
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        '&:hover': { backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLight || 'rgb(0, 155, 223)' },
        '&:disabled': {
            backgroundColor: '#C8C8C8',
            cursor: 'default' as const
        }
    },
    buttonText: {
        margin: 'auto 0',
        fontSize: '16px',
        fontWeight: 'bold' as const,
        lineHeight: '23px',
        textAlign: 'center' as const
    },
    contentStyling: {
        display: 'flex',
        alignItems: 'center' as const
    },
    iconStyling: { height: '15px' },
    mainButtonTextStyle: { color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF' },
    cancelButtonTextStyle: { color: theme?.app?.applicationColors.enumColors.grey || '#9b9b9b' },
    blueTextStyle: { color: theme?.app?.clientTheme.colors.buttons.primaryColorLighter || '#0096ff' },
    noBgBlueText: {
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        '&:hover:enabled': { color: theme?.app?.clientTheme.colors.primaryColorLight || '#009BDF' },
        '& > i': {
            marginRight: '2px',
            color: theme?.app?.clientTheme.colors.buttons.primaryColorLighter || '#0096FF'
        }
    }
}));